import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { Base } from '../base'

export const ReadonlyPhysicalInline = ({ fieldNamePrefix }) => {
  const baseFieldName = `${fieldNamePrefix}.location`
  const additionalFieldName = `${fieldNamePrefix}.additionalInfo`

  const [{ value }] = useFormField({ name: baseFieldName })
  const [{ value: additionalValue }] = useFormField({ name: additionalFieldName })

  return (
    <Base header={I18n.t('publisher.event_type_editor.sections.event_details.location.inlines.physical.header')}>
      <BodyText>{value}</BodyText>
      {additionalValue && <BodyText>{additionalValue}</BodyText>}
    </Base>
  )
}
